<template>
  <UiDrawer v-model="isOpen" width="300">
    <nav class="app-drawer">
      <router-link to="/" class="app-drawer__item" @click="isOpen = false">Главная</router-link>
      <router-link to="/catalog" class="app-drawer__item" @click="isOpen = false">Каталог</router-link>
      <router-link
        v-if="isSupplierShowcaseEnabled"
        to="/suppliers"
        class="app-drawer__item"
        @click="isOpen = false"
      >
        Поставщики
      </router-link>
      <router-link to="/favorites" class="app-drawer__item" @click="isOpen = false">
        Избранное
        <UiBadge v-if="favoritesCount > 0" variant="accent">{{ favoritesCount }}</UiBadge>
      </router-link>
      <div v-if="isAuthenticated" class="app-drawer__item" @click="isOpen = false">
        Уведомления
        <UiBadge v-if="unreadNotificationsCount > 0" variant="accent">
          {{ unreadNotificationsCount }}
        </UiBadge>
      </div>
      <div class="app-drawer__divider" />
      <div class="app-drawer__label">Поиск</div>
      <input
        v-model="searchQuery"
        type="search"
        class="app-drawer__input"
        placeholder="Поиск товаров..."
        @keyup.enter="onSearch"
      />
      <div class="app-drawer__divider" />
      <div class="app-drawer__label">Профиль</div>
      <template v-if="isAuthenticated">
        <router-link to="/profile" class="app-drawer__item" @click="isOpen = false">
          Мой профиль
        </router-link>
        <router-link
          :to="isAdmin ? '/admin/orders' : '/orders'"
          class="app-drawer__item"
          @click="isOpen = false"
        >
          Мои заказы
        </router-link>
        <router-link v-if="isChatEnabled" to="/chats" class="app-drawer__item" @click="isOpen = false">
          Сообщения
        </router-link>
        <template v-if="isAdmin">
          <div class="app-drawer__label">Администрирование</div>
        </template>
        <router-link v-if="isAdmin" to="/admin/dashboard" class="app-drawer__item" @click="isOpen = false">
          Админка
        </router-link>
        <router-link v-if="isAdmin" to="/admin/analytics" class="app-drawer__item" @click="isOpen = false">
          Аналитика
        </router-link>
        <router-link v-if="isAdmin" to="/admin/tools" class="app-drawer__item" @click="isOpen = false">
          Инструменты
        </router-link>
        <router-link
          v-if="((isBuyer || isSupplier) && isProcurementEnabled) || isAdmin"
          :to="isProcurementEnabled ? '/procurements' : '#'"
          class="app-drawer__item"
          @click="isProcurementEnabled && (isOpen = false)"
        >
          Закупки
          <UiBadge v-if="isAdmin && !isProcurementEnabled" variant="neutral">Откл.</UiBadge>
        </router-link>
        <button type="button" class="app-drawer__item app-drawer__item--btn" @click="emit('logout')">
          Выйти
        </button>
      </template>
      <template v-else>
        <div class="app-drawer__label">Аккаунт</div>
        <router-link to="/login" class="app-drawer__item" @click="isOpen = false">Войти</router-link>
        <router-link to="/register" class="app-drawer__item" @click="isOpen = false">
          Регистрация
        </router-link>
      </template>
      <div class="app-drawer__divider" />
      <div class="app-drawer__label">Информация</div>
      <router-link to="/about" class="app-drawer__item" @click="isOpen = false">О компании</router-link>
      <router-link to="/contacts" class="app-drawer__item" @click="isOpen = false">Контакты</router-link>
      <router-link to="/delivery" class="app-drawer__item" @click="isOpen = false">Доставка</router-link>
    </nav>
  </UiDrawer>
</template>

<script setup lang="ts">
import UiBadge from '@/shared/ui/UiBadge.vue'
import UiDrawer from '@/shared/ui/UiDrawer.vue'

defineProps<{
  isAuthenticated: boolean
  isAdmin: boolean
  isSupplier: boolean
  isBuyer: boolean
  isSupplierShowcaseEnabled: boolean
  isProcurementEnabled: boolean
  isChatEnabled: boolean
  favoritesCount: number
  unreadNotificationsCount: number
}>()

const emit = defineEmits<{
  search: []
  logout: []
}>()

const isOpen = defineModel<boolean>({ required: true })
const searchQuery = defineModel<string>('searchQuery', { required: true })

function onSearch() {
  emit('search')
}
</script>

<style scoped>
.app-drawer {
  padding: 16px;
}

.app-drawer__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px;
  color: #0f172a;
  text-decoration: none;
  font: inherit;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
  border-radius: 6px;
}

.app-drawer__item:hover {
  background: #f1f5f9;
}

.app-drawer__item--btn {
  cursor: pointer;
}

.app-drawer__divider {
  height: 1px;
  background: #e2e8f0;
  margin: 12px 0;
}

.app-drawer__label {
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #586578;
  text-transform: uppercase;
}

.app-drawer__input {
  width: 100%;
  padding: 10px 12px;
  margin-bottom: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font: inherit;
  box-sizing: border-box;
}
</style>
